import {FC} from 'react';
import {InputProps} from 'components/Form/types';
import InputSanitized from '../InputSanitized';
import sanitizePhoneNumber from './utils';

type InputPhoneNumberProps = InputProps & {
    isFax?: boolean;
};

const InputPhoneNumber: FC<InputPhoneNumberProps> = ({
    disabled,
    isFax,
    name,
    required,
    requiredType,
    rules,
    ...rest
}) => {
    const registerRules = rules || {
        disabled,
        required,
    };

    return (
        <InputSanitized
            inputMode="tel"
            name={name}
            rules={registerRules}
            sanitizer={sanitizePhoneNumber}
            {...rest}
        />
    );
};

export default InputPhoneNumber;
